// import node module libraries
import { Alert, Button, Col, Form, Row } from 'react-bootstrap';
import Select from 'react-select';

// import custom components
// import bootstrap icons
import { ExclamationTriangleFill } from 'react-bootstrap-icons';
import { useEffect, useState } from 'react';
import TypeLocalService from '../../services/TypeLocalService';

const OffcanvasAddTypeLocalForm = ({ onClick }) => {
	const [validated, setValidated] = useState(false);
	const [feedbackMessages, setFeedbackMessages] = useState({});
	const [showAlert, setShowAlert] = useState(false);
	const [alertMessage, setAlertMessage] = useState('');

	const handleSubmit = async (event) => {
		event.preventDefault();
		const form = event.currentTarget;

		if (form.checkValidity() === false) {
			event.stopPropagation();
		} else {
			try {
				const typeLocalData = new FormData();

				// Add all your form data to the FormData
				typeLocalData.append('type', form.type.value);

				// Call the TypeLocalService to create the TypeLocal
				const response = await TypeLocalService.createTypeLocal(typeLocalData);

				// Reset the form and state variables after successful creation
				form.reset();
				setValidated(false);
				setFeedbackMessages({});

				// Redirect the user to the list of TypeLocals
				window.location.href = '/assets/typelocal';
			} catch (error) {
				console.error('Erreur lors de la création du type de local', error);

				if (error.response && error.response.data) {
					const apiErrors = error.response.data;

					// If there are field-specific errors
					if (typeof apiErrors === 'object' && !Array.isArray(apiErrors)) {
						const newFeedbackMessages = {};

						for (const field in apiErrors) {
							newFeedbackMessages[field] = apiErrors[field][0];
						}

						setFeedbackMessages(newFeedbackMessages);
					}

					// If there's a general error detail message
					if (apiErrors.detail) {
						setAlertMessage(apiErrors.detail[0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					} else if (
						apiErrors['Il ya erreur'] &&
						apiErrors['Il ya erreur'][0]
					) {
						setAlertMessage(apiErrors['Il ya erreur'][0]);
						setShowAlert(true);

						// Hide the alert after 5 seconds
						setTimeout(() => {
							setShowAlert(false);
						}, 10000);
					}
				} else {
					alert(
						"Une erreur s'est produite lors de la soumission du formulaire."
					);
				}
			}
		}

		setValidated(true);
	};

	return (
		<Form
			className="mb-3"
			noValidate
			validated={validated}
			onSubmit={handleSubmit}
		>
			{showAlert && (
				<Alert variant="danger">
					<ExclamationTriangleFill size={25} className="me-1" />
					{alertMessage}
				</Alert>
			)}
			<Row>
				<Col xs={12} className="mb-3">
					{/* type et description  */}
					<Form.Group>
						<Row>
							<Col md={6} sm={12} className="mb-3">
								<Form.Label htmlFor="type">
									Type de Local <span className="text-danger">*</span>
								</Form.Label>
								<Form.Control
									name="type"
									type="text"
									placeholder="Saisir le Type de Local"
									id="type"
									required
									isInvalid={!!feedbackMessages['type']}
									onChange={(e) => {
										setFeedbackMessages((prevMessages) => ({
											...prevMessages,
											type: e.target.value ? '' : 'Le type est requis.'
										}));
									}}
								/>
								<Form.Control.Feedback type="invalid">
									{feedbackMessages['type']}
								</Form.Control.Feedback>
							</Col>
						</Row>
					</Form.Group>
				</Col>

				{/* Buttons */}
				<Col xs={12} className="mt-4">
					<Button variant="success" type="submit">
						Enregistrer
					</Button>
					<Button onClick={onClick} variant="outline-danger" className="ms-2">
						Fermer
					</Button>
				</Col>
			</Row>
		</Form>
	);
};

export default OffcanvasAddTypeLocalForm;
